import * as Yup from 'yup';

export interface IEvaluationTraineeFormInput {
  routine_id: number;
  id: number;
  evaluation_phase: number;
  title: string;
  passing_percentage: number;
  is_active: boolean;
  start_date_time: string;
  end_date_time: string;
}

export const EvaluationTraineeInitialValues: IEvaluationTraineeFormInput = {
  routine_id: 0,
  evaluation_phase: 1,
  id: 0,
  title: '',
  passing_percentage: 0,
  is_active: true,
  start_date_time: '',
  end_date_time: ''
};

export const EvaluationTraineeSchemaValidation = Yup.object().shape({
  routine_id: Yup.number().min(1, 'Routine is required').required('Routine is required'),

  evaluation_phase: Yup.number()
    .oneOf([1, 2], 'Phase must be Pre (1) or Post (2)')
    .required('Evaluation phase is required'),

  title: Yup.string()
    .trim()
    .min(3, 'Title must be at least 3 characters')
    .max(200, 'Title is too long')
    .required('Title is required'),

  passing_percentage: Yup.number()
    .min(0, 'Passing percentage cannot be negative')
    .max(100, 'Passing percentage cannot exceed 100')
    .required('Passing percentage is required'),

  is_active: Yup.boolean().required(),

  start_date_time: Yup.date()
    .required('Start date & time is required')
    .typeError('Invalid date format'),

  end_date_time: Yup.date()
    .required('End date & time is required')
    .typeError('Invalid date format')
    .min(Yup.ref('start_date_time'), 'End date must be after or equal to start date')
});
